import script from "./ImportPricePlansForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ImportPricePlansForm.vue?vue&type=script&setup=true&lang=js"

import "./ImportPricePlansForm.vue?vue&type=style&index=0&id=504fae80&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-504fae80"]])

export default __exports__